import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-charcoal text-white py-16 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="text-2xl font-light mb-4 tracking-wide">IV Hydration Club</h3>
            <p className="text-white/80 text-sm font-light leading-relaxed">
              Premium IV therapy and wellness treatments delivered with care and expertise.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-light mb-4 tracking-wide">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/80 hover:text-white text-sm font-light transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/80 hover:text-white text-sm font-light transition-colors cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/treatments" className="text-white/80 hover:text-white text-sm font-light transition-colors cursor-pointer">
                  Treatments
                </Link>
              </li>
              <li>
                <Link to="/membership" className="text-white/80 hover:text-white text-sm font-light transition-colors cursor-pointer">
                  Membership
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-white/80 hover:text-white text-sm font-light transition-colors cursor-pointer">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-light mb-4 tracking-wide">Services</h4>
            <ul className="space-y-3">
              <li>
                <span className="text-white/80 text-sm font-light">Vitamin IV Therapy</span>
              </li>
              <li>
                <span className="text-white/80 text-sm font-light">NAD+ Treatments</span>
              </li>
              <li>
                <span className="text-white/80 text-sm font-light">Wellness Memberships</span>
              </li>
              <li>
                <span className="text-white/80 text-sm font-light">Custom Formulations</span>
              </li>
              <li>
                <Link to="/book" className="text-white/80 hover:text-white text-sm font-light transition-colors cursor-pointer">
                  Book Appointment
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-light mb-4 tracking-wide">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="ri-phone-line text-lg mr-3 mt-0.5"></i>
                <span className="text-white/80 text-sm font-light">(555) 123-4567</span>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-lg mr-3 mt-0.5"></i>
                <span className="text-white/80 text-sm font-light">info@ivhydrationclub.com</span>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line text-lg mr-3 mt-0.5"></i>
                <span className="text-white/80 text-sm font-light">
                  123 Wellness Ave<br />
                  Los Angeles, CA 90210
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Social Media */}
        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-white/60 text-sm font-light mb-4 md:mb-0">
            © 2024 IV Hydration Club. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">
              <i className="ri-facebook-fill text-xl"></i>
            </a>
            <a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">
              <i className="ri-instagram-line text-xl"></i>
            </a>
            <a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">
              <i className="ri-twitter-x-line text-xl"></i>
            </a>
            <a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">
              <i className="ri-linkedin-fill text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
